// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";
// import Modal from "react-bootstrap/Modal";
// import {
//   addCityServ,
//   bulkDeleteCityServ,
//   deleteCityServ,
//   getCityServ,
//   getStateServ,
//   updateCityServ,
// } from "../../services/location.services";

// function CityList() {
//   const [list, setList] = useState([]);
//   const [states, setStates] = useState([]);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     stateId: "",
//     pageNo: 1,
//     pageCount: 10,
//   });

//   const [showSkelton, setShowSkelton] = useState(false);
//   const [statics, setStatics] = useState(null);
//   const [addFormData, setAddFormData] = useState({
//     name: "",
//     stateId: "",
//     status: "",
//     minimumPrice: "",
//     freeDeliveryLimit: "",
//     payDeliveryInAdvance: false,
//     deliveryOptionAvailable: [],
//     deliveryCharge: "",
//     _id: "",
//   });

//   const handleGetCities = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       const res = await getCityServ(payload);
//       setList(res.data.data);
//       setStatics(res.data.documentCount);
//     } catch (error) {
//       toast.error("Failed to load cities");
//     }
//     setShowSkelton(false);
//   };

//   const handleGetStates = async () => {
//     try {
//       const res = await getStateServ();
//       setStates(res.data.data);
//     } catch (error) {
//       toast.error("Failed to load states");
//     }
//   };

//   useEffect(() => {
//     handleGetStates();
//   }, []);

//   useEffect(() => {
//     handleGetCities();
//   }, [payload]);

//   const staticsArr = [
//     {
//       title: "Total City",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Active City",
//       count: statics?.activeCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Inactive City",
//       count: statics?.inactiveCount,
//       bgColor: "#FFA426",
//     },
//   ];

//   const [isLoading, setIsLoading] = useState(false);

//   const handleAddCityFunc = async () => {
//     setIsLoading(true);
//     try {
//       const payloadToSend = {
//         name: String(addFormData.name).trim(),
//         stateId: Number(addFormData.stateId),
//         status:
//           addFormData.status === true || addFormData.status === "true"
//             ? true
//             : addFormData.status === false || addFormData.status === "false"
//             ? false
//             : true, // default to active if empty
//         minimumPrice: Number(addFormData.minimumPrice),
//         deliveryCharge: Number(addFormData.deliveryCharge),
//         freeDeliveryLimit:
//           addFormData.freeDeliveryLimit === "" ||
//           addFormData.freeDeliveryLimit === undefined
//             ? 0
//             : Number(addFormData.freeDeliveryLimit),
//         payDeliveryInAdvance: Boolean(addFormData.payDeliveryInAdvance),
//         deliveryOptionAvailable: addFormData.deliveryOptionAvailable?.length
//           ? addFormData.deliveryOptionAvailable
//           : ["lorryPay"],
//       };

//       const response = await addCityServ(payloadToSend);
//       if (response?.data?.statusCode === 200) {
//         toast.success(response?.data?.message || "City added successfully!");
//         setAddFormData({
//           name: "",
//           stateId: "",
//           status: "",
//           minimumPrice: "",
//           deliveryCharge: "",
//           freeDeliveryLimit: "", // reset
//           payDeliveryInAdvance: false, // reset
//           deliveryOptionAvailable: [],
//           _id: "",
//           show: false,
//         });
//         handleGetCities();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Internal Server Error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteCity = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this city?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteCityServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetCities();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };
//   const [editFormData, setEditFormData] = useState({
//     name: "",
//     stateId: "",
//     status: "",
//     minimumPrice: "",
//     deliveryCharge: "",
//     freeDeliveryLimit: "",
//     payDeliveryInAdvance: false,
//     deliveryOptionAvailable: [],
//     _id: "",
//   });
//   const handleUpdateCityFunc = async () => {
//     setIsLoading(true);
//     try {
//       const payloadToSend = {
//         _id: editFormData._id,
//         name: String(editFormData.name).trim(),
//         stateId: Number(editFormData.stateId),
//         status:
//           editFormData.status === true || editFormData.status === "true"
//             ? true
//             : editFormData.status === false || editFormData.status === "false"
//             ? false
//             : undefined, // don't send if not set
//         minimumPrice:
//           editFormData.minimumPrice === ""
//             ? undefined
//             : Number(editFormData.minimumPrice),
//         deliveryCharge:
//           editFormData.deliveryCharge === ""
//             ? undefined
//             : Number(editFormData.deliveryCharge),
//         freeDeliveryLimit:
//           editFormData.freeDeliveryLimit === ""
//             ? 0
//             : Number(editFormData.freeDeliveryLimit),
//         payDeliveryInAdvance: Boolean(editFormData.payDeliveryInAdvance),
//         deliveryOptionAvailable: editFormData.deliveryOptionAvailable?.length
//           ? editFormData.deliveryOptionAvailable
//           : ["lorryPay"],
//       };

//       const response = await updateCityServ(payloadToSend);
//       if (
//         response?.data?.statusCode == "200" ||
//         response?.data?.statusCode === 200
//       ) {
//         toast.success(response?.data?.message || "City updated successfully!");
//         setEditFormData({
//           name: "",
//           stateId: "",
//           status: "",
//           minimumPrice: "",
//           deliveryCharge: "",
//           freeDeliveryLimit: "",
//           payDeliveryInAdvance: false,
//           deliveryOptionAvailable: [],
//           _id: "",
//         });
//         handleGetCities();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Internal Server Error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const [totalPages, setTotalPages] = useState(1);

//   useEffect(() => {
//     if (statics?.totalCount && payload.pageCount) {
//       const pages = Math.ceil(statics.totalCount / payload.pageCount);
//       setTotalPages(pages);
//     }
//   }, [statics, payload.pageCount]);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPayload({ ...payload, pageNo: newPage });
//     }
//   };

//   const [selectedCities, setSelectedCities] = useState([]);

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Location Management" selectedItem="City" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">City</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   value={payload.searchKey}
//                   onChange={(e) =>
//                     setPayload({
//                       ...payload,
//                       searchKey: e.target.value,
//                       pageNo: 1,
//                     })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn btn-primary w-100 borderRadius24"
//                   style={{ background: "#6777EF" }}
//                   onClick={() => setAddFormData({ ...addFormData, show: true })}
//                 >
//                   Add City
//                 </button>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <button
//                 className="btn btn-danger borderRadius24 text-light p-2 mx-2"
//                 disabled={selectedCities.length === 0}
//                 onClick={async () => {
//                   if (
//                     window.confirm(`Delete ${selectedCities.length} cities?`)
//                   ) {
//                     try {
//                       const res = await bulkDeleteCityServ(selectedCities);
//                       toast.success(res.data.message);
//                       setSelectedCities([]);
//                       handleGetCities();
//                     } catch (err) {
//                       toast.error("Bulk delete failed");
//                     }
//                   }
//                 }}
//               >
//                 Delete Selected
//               </button>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th className="text-center py-3">
//                         <label
//                           style={{ cursor: "pointer", userSelect: "none" }}
//                         >
//                           <input
//                             type="checkbox"
//                             style={{ marginRight: "5px" }}
//                             checked={
//                               list?.length > 0 &&
//                               selectedCities?.length === list?.length
//                             }
//                             onChange={(e) => {
//                               if (e.target.checked) {
//                                 setSelectedCities(list.map((c) => c._id)); // select all
//                               } else {
//                                 setSelectedCities([]); // unselect all
//                               }
//                             }}
//                           />
//                           Select All
//                         </label>
//                       </th>
//                       <th className="text-center py-3">Id</th>
//                       <th className="text-center py-3">City Name</th>
//                       <th className="text-center py-3">Minimum Price</th>
//                       <th className="text-center py-3">Delivery Charge</th>
//                       <th className="text-center py-3">Delivery Options</th>
//                       <th className="text-center py-3">Status</th>
//                       <th className="text-center py-3">Free Delivery Limit</th>
//                       <th className="text-center py-3">Advance Payment</th>
//                       {/* <th className="text-center py-3">Created At</th> */}
//                       <th className="text-center py-3">Action</th>
//                     </tr>

//                     <div className="py-2"></div>

//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => (
//                           <tr key={i}>
//                             <td className="text-center">
//                               <Skeleton width={50} height={50} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton
//                                 width={50}
//                                 height={50}
//                                 borderRadius={25}
//                               />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                           </tr>
//                         ))
//                       : list?.map((v, i) => (
//                           <tr key={i}>
//                             <td className="text-center">
//                               <label
//                                 style={{
//                                   cursor: "pointer",
//                                   userSelect: "none",
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   style={{ marginRight: "5px" }}
//                                   checked={selectedCities.includes(v._id)}
//                                   onChange={(e) => {
//                                     if (e.target.checked) {
//                                       setSelectedCities([
//                                         ...selectedCities,
//                                         v._id,
//                                       ]);
//                                     } else {
//                                       setSelectedCities(
//                                         selectedCities.filter(
//                                           (id) => id !== v._id
//                                         )
//                                       );
//                                     }
//                                   }}
//                                 />
//                                 Select
//                               </label>
//                             </td>

//                             <td className="text-center">{v?.cityId}</td>
//                             <td className="font-weight-600 text-center">
//                               {v?.name}
//                             </td>
//                             <td className="font-weight-600 text-center">
//                               {v?.minimumPrice}
//                             </td>
//                             <td className="font-weight-600 text-center">
//                               {v?.deliveryCharge}
//                             </td>

//                             <td className="text-center">
//                               {(v?.deliveryOptionAvailable || [])
//                                 .map((o) =>
//                                   o === "homeDelivery"
//                                     ? "Door Delivery"
//                                     : "Pickup at Lorry Transport"
//                                 )
//                                 .join(", ")}
//                             </td>

//                             <td className="text-center">
//                               {v?.status ? (
//                                 <div
//                                   className="badge py-2"
//                                   style={{ background: "#63ED7A" }}
//                                 >
//                                   Active
//                                 </div>
//                               ) : (
//                                 <div
//                                   className="badge py-2"
//                                   style={{ background: "#FFA426" }}
//                                 >
//                                   Inactive
//                                 </div>
//                               )}
//                             </td>
//                             <td className="font-weight-600 text-center">
//                               {v?.freeDeliveryLimit ?? 0}
//                             </td>
//                             <td className="text-center">
//                               {v?.payDeliveryInAdvance ? "Yes" : "No"}
//                             </td>

//                             {/* <td className="text-center">
//                               {moment(v?.createdAt).format("DD-MM-YY")}
//                             </td> */}

//                             <td className="text-center">
//                               <a
//                                 onClick={() =>
//                                   setEditFormData({
//                                     name: v?.name,
//                                     status: v?.status,
//                                     stateId: v?.stateId || "",
//                                     minimumPrice: v?.minimumPrice || "",
//                                     deliveryCharge: v?.deliveryCharge || "",
//                                     freeDeliveryLimit:
//                                       v?.freeDeliveryLimit ?? "",
//                                     payDeliveryInAdvance:
//                                       !!v?.payDeliveryInAdvance,
//                                     _id: v?._id,
//                                     deliveryOptionAvailable:
//                                       v?.deliveryOptionAvailable || [],
//                                   })
//                                 }
//                                 className="btn btn-info mx-2 text-light shadow-sm"
//                               >
//                                 Edit
//                               </a>
//                               <a
//                                 onClick={() => handleDeleteCity(v?._id)}
//                                 className="btn btn-warning mx-2 text-light shadow-sm"
//                               >
//                                 Delete
//                               </a>
//                             </td>
//                           </tr>
//                         ))}
//                   </tbody>
//                 </table>

//                 <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5 px-3 py-3 mt-4">
//                   <div className="d-flex align-items-center gap-2">
//                     <span className="fw-semibold text-secondary">Show</span>
//                     <select
//                       className="form-select form-select-sm custom-select"
//                       value={payload.pageCount}
//                       onChange={(e) =>
//                         setPayload({
//                           ...payload,
//                           pageCount: parseInt(e.target.value),
//                           pageNo: 1,
//                         })
//                       }
//                     >
//                       {[10, 25, 50, 100].map((v) => (
//                         <option key={v} value={v}>
//                           {v}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <nav>
//                     <ul className="pagination pagination-sm mb-0 custom-pagination">
//                       <li
//                         className={`page-item ${
//                           payload.pageNo === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo - 1)}
//                         >
//                           &lt;
//                         </button>
//                       </li>

//                       {[...Array(totalPages)].map((_, i) => {
//                         const page = i + 1;
//                         if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= payload.pageNo - 1 &&
//                             page <= payload.pageNo + 1)
//                         ) {
//                           return (
//                             <li
//                               key={page}
//                               className={`page-item ${
//                                 payload.pageNo === page ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => handlePageChange(page)}
//                               >
//                                 {page}
//                               </button>
//                             </li>
//                           );
//                         } else if (
//                           (page === payload.pageNo - 2 && page > 2) ||
//                           (page === payload.pageNo + 2 && page < totalPages - 1)
//                         ) {
//                           return (
//                             <li key={page} className="page-item disabled">
//                               <span className="page-link">...</span>
//                             </li>
//                           );
//                         }
//                         return null;
//                       })}

//                       <li
//                         className={`page-item ${
//                           payload.pageNo === totalPages ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo + 1)}
//                         >
//                           &gt;
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>

//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {addFormData?.show && (
//         <div
//           className="modal fade show d-flex align-items-center justify-content-center"
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px", cursor: "pointer" }}
//                   onClick={() =>
//                     setAddFormData({
//                       stateId: "",
//                       name: "",
//                       minimumPrice: "",
//                       deliveryCharge: "",
//                       freeDeliveryLimit: "",
//                       payDeliveryInAdvance: "",
//                       deliveryOptionAvailable: [],
//                       status: "",
//                       show: false,
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div className="d-flex justify-content-center w-100">
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Add City</h5>

//                     <label className="mt-3">State</label>
//                     <select
//                       className="form-control"
//                       value={addFormData.stateId}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           stateId: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select State</option>
//                       {states.map((state) => (
//                         <option key={state.stateId} value={state.stateId}>
//                           {state.name}
//                         </option>
//                       ))}
//                     </select>

//                     <label className="mt-3">City Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       value={addFormData.name}
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, name: e.target.value })
//                       }
//                     />

//                     <label className="mt-3">Delivery Charge</label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       value={addFormData.deliveryCharge}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           deliveryCharge: e.target.value,
//                         })
//                       }
//                     />

//                     <label className="mt-3">Delivery Options</label>
//                     <div className="d-flex gap-3">
//                       {["homeDelivery", "lorryPay"].map((opt) => (
//                         <label key={opt} style={{ userSelect: "none" }}>
//                           <input
//                             type="checkbox"
//                             className="me-2"
//                             checked={addFormData.deliveryOptionAvailable.includes(
//                               opt
//                             )}
//                             onChange={(e) => {
//                               const checked = e.target.checked;
//                               setAddFormData((prev) => {
//                                 const set = new Set(
//                                   prev.deliveryOptionAvailable
//                                 );
//                                 if (checked) set.add(opt);
//                                 else set.delete(opt);
//                                 return {
//                                   ...prev,
//                                   deliveryOptionAvailable: Array.from(set),
//                                 };
//                               });
//                             }}
//                           />
//                           {opt === "homeDelivery"
//                             ? "Door Delivery"
//                             : "Pickup at Lorry Transport"}
//                         </label>
//                       ))}
//                     </div>

//                     <label className="mt-3">
//                       Free Delivery Order Value (Rs )
//                     </label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       value={addFormData.freeDeliveryLimit}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           freeDeliveryLimit:
//                             e.target.value === ""
//                               ? ""
//                               : Math.max(0, Number(e.target.value)),
//                         })
//                       }
//                     />

//                     <div className="form-check mt-3">
//                       <input
//                         className="form-check-input"
//                         type="checkbox"
//                         id="addPayAdvance"
//                         checked={!!addFormData.payDeliveryInAdvance}
//                         onChange={(e) =>
//                           setAddFormData({
//                             ...addFormData,
//                             payDeliveryInAdvance: e.target.checked,
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="addPayAdvance"
//                       >
//                         Collect delivery charges in advance for Lorry Pickup
//                       </label>
//                     </div>

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       value={addFormData.status}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           status: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>

//                     <label className="mt-3">Minimum Price</label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       value={addFormData.minimumPrice}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           minimumPrice: e.target.value,
//                         })
//                       }
//                     />

//                     <button
//                       className="btn btn-success w-100 mt-4"
//                       onClick={
//                         addFormData.name &&
//                         addFormData?.stateId &&
//                         addFormData.minimumPrice &&
//                         addFormData?.deliveryCharge &&
//                         !isLoading
//                           ? handleAddCityFunc
//                           : undefined
//                       }
//                       disabled={
//                         !addFormData.name ||
//                         !addFormData?.stateId ||
//                         !addFormData.minimumPrice ||
//                         !addFormData?.deliveryCharge ||
//                         isLoading
//                       }
//                       style={{
//                         opacity:
//                           !addFormData.name ||
//                           !addFormData?.stateId ||
//                           !addFormData.minimumPrice ||
//                           !addFormData?.deliveryCharge ||
//                           isLoading
//                             ? "0.5"
//                             : "1",
//                       }}
//                     >
//                       {isLoading ? "Saving..." : "Submit"}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {addFormData?.show && <div className="modal-backdrop fade show"></div>}

//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center justify-content-center"
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px", cursor: "pointer" }}
//                   onClick={() =>
//                     setEditFormData({
//                       name: "",
//                       stateId: "",
//                       minimumPrice: "",
//                       deliveryCharge: "",
//                       freeDeliveryLimit: "",
//                       payDeliveryInAdvance: "",
//                       deliveryOptionAvailable: [],
//                       _id: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div className="d-flex justify-content-center w-100">
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update City</h5>

//                     <label className="mt-3">City Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           name: e.target.value,
//                         })
//                       }
//                       value={editFormData?.name}
//                     />

//                     <label className="mt-3">State</label>
//                     <select
//                       className="form-control"
//                       value={editFormData?.stateId}
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           stateId: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select State</option>
//                       {states.map((state) => (
//                         <option key={state.stateId} value={state.stateId}>
//                           {state.name}
//                         </option>
//                       ))}
//                     </select>

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           status: e.target.value,
//                         })
//                       }
//                       value={editFormData?.status}
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>

//                     <label className="mt-3">Minimum Price</label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           minimumPrice: e.target.value,
//                         })
//                       }
//                       value={editFormData?.minimumPrice}
//                     />

//                     <label className="mt-3">Delivery Charge</label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           deliveryCharge: e.target.value,
//                         })
//                       }
//                       value={editFormData?.deliveryCharge}
//                     />

//                     <label className="mt-3">Delivery Options</label>
//                     <div className="d-flex gap-3">
//                       {["homeDelivery", "lorryPay"].map((opt) => (
//                         <label key={opt} style={{ userSelect: "none" }}>
//                           <input
//                             type="checkbox"
//                             className="me-2"
//                             checked={editFormData.deliveryOptionAvailable.includes(
//                               opt
//                             )}
//                             onChange={(e) => {
//                               const checked = e.target.checked;
//                               setEditFormData((prev) => {
//                                 const set = new Set(
//                                   prev.deliveryOptionAvailable
//                                 );
//                                 if (checked) set.add(opt);
//                                 else set.delete(opt);
//                                 return {
//                                   ...prev,
//                                   deliveryOptionAvailable: Array.from(set),
//                                 };
//                               });
//                             }}
//                           />
//                           {opt === "homeDelivery"
//                             ? "Door Delivery"
//                             : "Pickup at Lorry Transport"}
//                         </label>
//                       ))}
//                     </div>

//                     <label className="mt-3">
//                       Free Delivery Order Value (Rs )
//                     </label>
//                     <input
//                       className="form-control"
//                       type="number"
//                       min="0"
//                       value={editFormData.freeDeliveryLimit}
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           freeDeliveryLimit:
//                             e.target.value === ""
//                               ? ""
//                               : Math.max(0, Number(e.target.value)),
//                         })
//                       }
//                     />

//                     <div className="form-check mt-3">
//                       <input
//                         className="form-check-input"
//                         type="checkbox"
//                         id="editPayAdvance"
//                         checked={!!editFormData.payDeliveryInAdvance}
//                         onChange={(e) =>
//                           setEditFormData({
//                             ...editFormData,
//                             payDeliveryInAdvance: e.target.checked,
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="editPayAdvance"
//                       >
//                         Collect delivery charges in advance for Lorry Pickup
//                       </label>
//                     </div>

//                     {editFormData?.name &&
//                     editFormData?.stateId &&
//                     editFormData?.minimumPrice &&
//                     editFormData?.deliveryCharge ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleUpdateCityFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                         disabled
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default CityList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import Modal from "react-bootstrap/Modal";
import {
  addCityServ,
  bulkDeleteCityServ,
  deleteCityServ,
  getCityServ,
  getStateServ,
  updateCityServ,
} from "../../services/location.services";

function CityList() {
  const [list, setList]       = useState([]);
  const [states, setStates]   = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "", status: "", stateId: "", pageNo: 1, pageCount: 10,
  });
  const [showSkelton, setShowSkelton]   = useState(false);
  const [isLoading, setIsLoading]       = useState(false);
  const [selectedCities, setSelectedCities] = useState([]);
  const [totalPages, setTotalPages]     = useState(1);

  /* ── Add form ── */
  const [addFormData, setAddFormData] = useState({
    name: "", stateId: "", status: "", minimumPrice: "",
    freeDeliveryLimit: "", payDeliveryInAdvance: false,
    deliveryOptionAvailable: [], deliveryCharge: "", _id: "", show: false,
  });

  /* ── Edit form ── */
  const [editFormData, setEditFormData] = useState({
    name: "", stateId: "", status: "", minimumPrice: "",
    deliveryCharge: "", freeDeliveryLimit: "",
    payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "",
  });

  /* ── Data fetchers ── */
  const handleGetCities = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      const res = await getCityServ(payload);
      setList(res.data.data);
      setStatics(res.data.documentCount);
    } catch (error) { toast.error("Failed to load cities"); }
    setShowSkelton(false);
  };

  const handleGetStates = async () => {
    try {
      const res = await getStateServ();
      setStates(res.data.data);
    } catch (error) { toast.error("Failed to load states"); }
  };

  useEffect(() => { handleGetStates(); }, []);
  useEffect(() => { handleGetCities(); }, [payload]);
  useEffect(() => {
    if (statics?.totalCount && payload.pageCount)
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
  }, [statics, payload.pageCount]);

  /* ── Add ── */
  const handleAddCityFunc = async () => {
    setIsLoading(true);
    try {
      const payloadToSend = {
        name:                   String(addFormData.name).trim(),
        stateId:                Number(addFormData.stateId),
        status:                 addFormData.status === true || addFormData.status === "true" ? true
                                : addFormData.status === false || addFormData.status === "false" ? false : true,
        minimumPrice:           Number(addFormData.minimumPrice),
        deliveryCharge:         Number(addFormData.deliveryCharge),
        freeDeliveryLimit:      addFormData.freeDeliveryLimit === "" || addFormData.freeDeliveryLimit === undefined ? 0 : Number(addFormData.freeDeliveryLimit),
        payDeliveryInAdvance:   Boolean(addFormData.payDeliveryInAdvance),
        deliveryOptionAvailable: addFormData.deliveryOptionAvailable?.length ? addFormData.deliveryOptionAvailable : ["lorryPay"],
      };
      const response = await addCityServ(payloadToSend);
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "City added successfully!");
        setAddFormData({ name: "", stateId: "", status: "", minimumPrice: "", deliveryCharge: "", freeDeliveryLimit: "", payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "", show: false });
        handleGetCities();
      }
    } catch (error) { toast.error(error?.response?.data?.message || "Internal Server Error"); }
    finally { setIsLoading(false); }
  };

  /* ── Delete ── */
  const handleDeleteCity = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this city?");
    if (confirmed) {
      try {
        let response = await deleteCityServ(id);
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetCities();
        }
      } catch (error) { toast.error(error?.response?.data?.message || "Internal Server Error"); }
    }
  };

  /* ── Update ── */
  const handleUpdateCityFunc = async () => {
    setIsLoading(true);
    try {
      const payloadToSend = {
        _id:                    editFormData._id,
        name:                   String(editFormData.name).trim(),
        stateId:                Number(editFormData.stateId),
        status:                 editFormData.status === true || editFormData.status === "true" ? true
                                : editFormData.status === false || editFormData.status === "false" ? false : undefined,
        minimumPrice:           editFormData.minimumPrice === "" ? undefined : Number(editFormData.minimumPrice),
        deliveryCharge:         editFormData.deliveryCharge === "" ? undefined : Number(editFormData.deliveryCharge),
        freeDeliveryLimit:      editFormData.freeDeliveryLimit === "" ? 0 : Number(editFormData.freeDeliveryLimit),
        payDeliveryInAdvance:   Boolean(editFormData.payDeliveryInAdvance),
        deliveryOptionAvailable: editFormData.deliveryOptionAvailable?.length ? editFormData.deliveryOptionAvailable : ["lorryPay"],
      };
      const response = await updateCityServ(payloadToSend);
      if (response?.data?.statusCode == "200" || response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "City updated successfully!");
        setEditFormData({ name: "", stateId: "", status: "", minimumPrice: "", deliveryCharge: "", freeDeliveryLimit: "", payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "" });
        handleGetCities();
      }
    } catch (error) { toast.error(error?.response?.data?.message || "Internal Server Error"); }
    finally { setIsLoading(false); }
  };

  /* ── Pagination ── */
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages)
      setPayload({ ...payload, pageNo: newPage });
  };

  /* ── Delivery option toggle helper ── */
  const toggleDeliveryOpt = (opt, current, setter) => {
    const set = new Set(current);
    set.has(opt) ? set.delete(opt) : set.add(opt);
    setter(Array.from(set));
  };

  const addValid  = addFormData.name && addFormData.stateId && addFormData.minimumPrice && addFormData.deliveryCharge;
  const editValid = editFormData.name && editFormData.stateId && editFormData.minimumPrice && editFormData.deliveryCharge;

  /* ── Delivery option label ── */
  const deliveryLabel = (opt) => opt === "homeDelivery" ? "Door Delivery" : "Pickup at Lorry Transport";

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Location Management" selectedItem="City" />

      <div className="mainContainer">
        <TopNav pageTitle="City" pagePath="Home / Location Management / City" />

        <div className="pl-root">

          {/* ── Stat Cards ── */}
          <div className="pl-stat-grid">
            {[
              { title: "Total City",    count: statics?.totalCount,    icon: "ti-building-community" },
              { title: "Active City",   count: statics?.activeCount,   icon: "ti-circle-check"       },
              { title: "Inactive City", count: statics?.inactiveCount, icon: "ti-circle-x"           },
            ].map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="pl-stat-val">{v.count ?? "—"}</div>
                  <div className="pl-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="pl-toolbar">
            <span className="pl-toolbar-title">City</span>

            <input
              className="pl-input"
              placeholder="Search cities..."
              value={payload.searchKey}
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value, pageNo: 1 })}
            />

            <select
              className="pl-select"
              onChange={(e) => setPayload({ ...payload, status: e.target.value })}
            >
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button
              className="pl-btn pl-btn-red"
              onClick={() => setAddFormData({ ...addFormData, show: true })}
            >
              <i className="ti ti-plus" aria-hidden="true" />
              Add City
            </button>

            <button
              className="pl-btn pl-btn-danger"
              disabled={selectedCities.length === 0}
              style={{ opacity: selectedCities.length === 0 ? 0.45 : 1 }}
              onClick={async () => {
                if (window.confirm(`Delete ${selectedCities.length} cities?`)) {
                  try {
                    const res = await bulkDeleteCityServ(selectedCities);
                    toast.success(res.data.message);
                    setSelectedCities([]);
                    handleGetCities();
                  } catch (err) { toast.error("Bulk delete failed"); }
                }
              }}
            >
              <i className="ti ti-trash" aria-hidden="true" />
              Delete Selected
              {selectedCities.length > 0 && (
                <span
                  style={{
                    background: "#a60808", color: "#fff",
                    borderRadius: "20px", fontSize: 11, fontWeight: 700,
                    padding: "1px 7px", marginLeft: 4,
                  }}
                >
                  {selectedCities.length}
                </span>
              )}
            </button>
          </div>

          {/* ── Table ── */}
          <div className="pl-table-wrap">
            <div className="pl-table-scroll">
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>
                      <label className="pl-check-label">
                        <input
                          type="checkbox"
                          className="pl-check"
                          checked={list?.length > 0 && selectedCities?.length === list?.length}
                          onChange={(e) =>
                            setSelectedCities(e.target.checked ? list.map((c) => c._id) : [])
                          }
                        />
                        All
                      </label>
                    </th>
                    <th>City ID</th>
                    <th>City Name</th>
                    <th>Min. Price</th>
                    <th>Delivery Charge</th>
                    <th>Delivery Options</th>
                    <th>Status</th>
                    <th>Free Delivery Limit</th>
                    <th>Advance Payment</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(8)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(10)].map((__, j) => (
                          <td key={j} className="pl-skel-cell"><Skeleton height={18} /></td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="10" style={{ textAlign: "center", padding: "48px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v._id}>

                        {/* Checkbox */}
                        <td>
                          <input
                            type="checkbox"
                            className="pl-check"
                            checked={selectedCities.includes(v._id)}
                            onChange={(e) =>
                              setSelectedCities(
                                e.target.checked
                                  ? [...selectedCities, v._id]
                                  : selectedCities.filter((id) => id !== v._id)
                              )
                            }
                          />
                        </td>

                        {/* City ID */}
                        <td>
                          <span className="pl-sr">{v?.cityId}</span>
                        </td>

                        {/* City Name */}
                        <td style={{ fontWeight: 600, color: "#1c0a0a" }}>
                          {v?.name}
                        </td>

                        {/* Min Price */}
                        <td>
                          <span className="pl-price-main" style={{ fontSize: 14 }}>
                            Rs {v?.minimumPrice}
                          </span>
                        </td>

                        {/* Delivery Charge */}
                        <td>
                          <span className="pl-price-main" style={{ fontSize: 14 }}>
                            Rs {v?.deliveryCharge}
                          </span>
                        </td>

                        {/* Delivery Options */}
                        <td>
                          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                            {(v?.deliveryOptionAvailable || []).map((opt) => (
                              <span key={opt} className="pl-cat-chip" style={{ fontSize: 11 }}>
                                {deliveryLabel(opt)}
                              </span>
                            ))}
                          </div>
                        </td>

                        {/* Status */}
                        <td>
                          <span className={`pl-badge ${v?.status ? "active" : "inactive"}`}>
                            <i
                              className={`ti ${v?.status ? "ti-circle-check" : "ti-circle-x"}`}
                              style={{ fontSize: 13 }}
                              aria-hidden="true"
                            />
                            {v?.status ? "Active" : "Inactive"}
                          </span>
                        </td>

                        {/* Free Delivery Limit */}
                        <td>
                          <span style={{
                            display: "inline-block", background: "#f5f5f7",
                            borderRadius: 7, padding: "3px 12px",
                            fontSize: 13, fontWeight: 600, color: "#555", fontFamily: "monospace",
                          }}>
                            Rs {v?.freeDeliveryLimit ?? 0}
                          </span>
                        </td>

                        {/* Advance Payment */}
                        <td>
                          <span className={`pl-badge ${v?.payDeliveryInAdvance ? "active" : "inactive"}`}
                            style={{ fontSize: 12 }}>
                            {v?.payDeliveryInAdvance ? "Yes" : "No"}
                          </span>
                        </td>

                        {/* Actions */}
                        <td>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              className="pl-view-btn"
                              onClick={() =>
                                setEditFormData({
                                  name:                    v?.name,
                                  status:                  v?.status,
                                  stateId:                 v?.stateId || "",
                                  minimumPrice:            v?.minimumPrice || "",
                                  deliveryCharge:          v?.deliveryCharge || "",
                                  freeDeliveryLimit:       v?.freeDeliveryLimit ?? "",
                                  payDeliveryInAdvance:    !!v?.payDeliveryInAdvance,
                                  _id:                     v?._id,
                                  deliveryOptionAvailable: v?.deliveryOptionAvailable || [],
                                })
                              }
                            >
                              <i className="ti ti-pencil" aria-hidden="true" />
                              Edit
                            </button>

                            <button
                              className="pl-btn pl-btn-danger"
                              style={{ height: 34, padding: "0 14px", fontSize: 14 }}
                              onClick={() => handleDeleteCity(v?._id)}
                            >
                              <i className="ti ti-trash" aria-hidden="true" />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="pl-pagination">
              <div className="pl-show-row">
                Show
                <select
                  className="pl-select"
                  style={{ height: 36, padding: "0 10px" }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="pl-page-btns">
                <button className="pl-pg-btn" disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}>
                  <i className="ti ti-chevron-left" style={{ fontSize: 13 }} />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)) {
                    return (
                      <button key={page}
                        className={`pl-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}>
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)) {
                    return <button key={page} className="pl-pg-btn" disabled>...</button>;
                  }
                  return null;
                })}

                <button className="pl-pg-btn" disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}>
                  <i className="ti ti-chevron-right" style={{ fontSize: 13 }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          ADD CITY MODAL
      ══════════════════════════════════════ */}
      {addFormData?.show && (
        <div className="pl-modal-overlay">
          <div className="pl-modal" style={{ width: 440, maxWidth: "95vw" }}>
            <div className="pl-modal-header">
              <span className="pl-modal-title">Add City</span>
              <button className="pl-modal-close"
                onClick={() => setAddFormData({
                  name: "", stateId: "", status: "", minimumPrice: "",
                  deliveryCharge: "", freeDeliveryLimit: "",
                  payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "", show: false,
                })}>
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>

              <label className="pl-field-label">State</label>
              <select className="pl-field-input" style={{ cursor: "pointer" }}
                value={addFormData.stateId}
                onChange={(e) => setAddFormData({ ...addFormData, stateId: e.target.value })}>
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>{state.name}</option>
                ))}
              </select>

              <label className="pl-field-label">City Name</label>
              <input className="pl-field-input" type="text" placeholder="City name"
                value={addFormData.name}
                onChange={(e) => setAddFormData({ ...addFormData, name: e.target.value })} />

              <label className="pl-field-label">Minimum Price (Rs )</label>
              <input className="pl-field-input" type="number" min="0" placeholder="0"
                value={addFormData.minimumPrice}
                onChange={(e) => setAddFormData({ ...addFormData, minimumPrice: e.target.value })} />

              <label className="pl-field-label">Delivery Charge (Rs )</label>
              <input className="pl-field-input" type="number" min="0" placeholder="0"
                value={addFormData.deliveryCharge}
                onChange={(e) => setAddFormData({ ...addFormData, deliveryCharge: e.target.value })} />

              <label className="pl-field-label">Free Delivery Order Value (Rs )</label>
              <input className="pl-field-input" type="number" min="0" placeholder="0"
                value={addFormData.freeDeliveryLimit}
                onChange={(e) => setAddFormData({
                  ...addFormData,
                  freeDeliveryLimit: e.target.value === "" ? "" : Math.max(0, Number(e.target.value)),
                })} />

              <label className="pl-field-label">Delivery Options</label>
              <div style={{ display: "flex", gap: 16, marginBottom: 14 }}>
                {["homeDelivery", "lorryPay"].map((opt) => (
                  <label key={opt} style={{ display: "flex", alignItems: "center", gap: 7, cursor: "pointer", fontSize: 14, color: "#444" }}>
                    <input
                      type="checkbox"
                      className="pl-check"
                      checked={addFormData.deliveryOptionAvailable.includes(opt)}
                      onChange={() =>
                        toggleDeliveryOpt(
                          opt,
                          addFormData.deliveryOptionAvailable,
                          (val) => setAddFormData((p) => ({ ...p, deliveryOptionAvailable: val }))
                        )
                      }
                    />
                    {deliveryLabel(opt)}
                  </label>
                ))}
              </div>

              <label className="pl-field-label">Status</label>
              <select className="pl-field-input" style={{ cursor: "pointer" }}
                value={addFormData.status}
                onChange={(e) => setAddFormData({ ...addFormData, status: e.target.value })}>
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>

              <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", fontSize: 13, color: "#555", marginBottom: 14, lineHeight: 1.5 }}>
                <input
                  type="checkbox"
                  className="pl-check"
                  style={{ marginTop: 2, flexShrink: 0 }}
                  id="addPayAdvance"
                  checked={!!addFormData.payDeliveryInAdvance}
                  onChange={(e) => setAddFormData({ ...addFormData, payDeliveryInAdvance: e.target.checked })}
                />
                Collect delivery charges in advance for Lorry Pickup
              </label>

            </div>

            <div className="pl-modal-footer">
              <button className="pl-btn" style={{ background: "#f0f0f0", color: "#555", height: 40 }}
                onClick={() => setAddFormData({
                  name: "", stateId: "", status: "", minimumPrice: "",
                  deliveryCharge: "", freeDeliveryLimit: "",
                  payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "", show: false,
                })}>
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: 40, opacity: addValid && !isLoading ? 1 : 0.5 }}
                disabled={!addValid || isLoading}
                onClick={addValid && !isLoading ? handleAddCityFunc : undefined}
              >
                {isLoading ? "Saving..." : "Save City"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          EDIT CITY MODAL
      ══════════════════════════════════════ */}
      {editFormData?._id && (
        <div className="pl-modal-overlay">
          <div className="pl-modal" style={{ width: 440, maxWidth: "95vw" }}>
            <div className="pl-modal-header">
              <span className="pl-modal-title">Update City</span>
              <button className="pl-modal-close"
                onClick={() => setEditFormData({
                  name: "", stateId: "", status: "", minimumPrice: "",
                  deliveryCharge: "", freeDeliveryLimit: "",
                  payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "",
                })}>
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>

              <label className="pl-field-label">City Name</label>
              <input className="pl-field-input" type="text"
                value={editFormData.name}
                onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })} />

              <label className="pl-field-label">State</label>
              <select className="pl-field-input" style={{ cursor: "pointer" }}
                value={editFormData.stateId}
                onChange={(e) => setEditFormData({ ...editFormData, stateId: e.target.value })}>
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>{state.name}</option>
                ))}
              </select>

              <label className="pl-field-label">Status</label>
              <select className="pl-field-input" style={{ cursor: "pointer" }}
                value={editFormData.status}
                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}>
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>

              <label className="pl-field-label">Minimum Price (Rs )</label>
              <input className="pl-field-input" type="number" min="0"
                value={editFormData.minimumPrice}
                onChange={(e) => setEditFormData({ ...editFormData, minimumPrice: e.target.value })} />

              <label className="pl-field-label">Delivery Charge (Rs )</label>
              <input className="pl-field-input" type="number" min="0"
                value={editFormData.deliveryCharge}
                onChange={(e) => setEditFormData({ ...editFormData, deliveryCharge: e.target.value })} />

              <label className="pl-field-label">Free Delivery Order Value (Rs )</label>
              <input className="pl-field-input" type="number" min="0"
                value={editFormData.freeDeliveryLimit}
                onChange={(e) => setEditFormData({
                  ...editFormData,
                  freeDeliveryLimit: e.target.value === "" ? "" : Math.max(0, Number(e.target.value)),
                })} />

              <label className="pl-field-label">Delivery Options</label>
              <div style={{ display: "flex", gap: 16, marginBottom: 14 }}>
                {["homeDelivery", "lorryPay"].map((opt) => (
                  <label key={opt} style={{ display: "flex", alignItems: "center", gap: 7, cursor: "pointer", fontSize: 14, color: "#444" }}>
                    <input
                      type="checkbox"
                      className="pl-check"
                      checked={editFormData.deliveryOptionAvailable.includes(opt)}
                      onChange={() =>
                        toggleDeliveryOpt(
                          opt,
                          editFormData.deliveryOptionAvailable,
                          (val) => setEditFormData((p) => ({ ...p, deliveryOptionAvailable: val }))
                        )
                      }
                    />
                    {deliveryLabel(opt)}
                  </label>
                ))}
              </div>

              <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", fontSize: 13, color: "#555", marginBottom: 14, lineHeight: 1.5 }}>
                <input
                  type="checkbox"
                  className="pl-check"
                  style={{ marginTop: 2, flexShrink: 0 }}
                  id="editPayAdvance"
                  checked={!!editFormData.payDeliveryInAdvance}
                  onChange={(e) => setEditFormData({ ...editFormData, payDeliveryInAdvance: e.target.checked })}
                />
                Collect delivery charges in advance for Lorry Pickup
              </label>

            </div>

            <div className="pl-modal-footer">
              <button className="pl-btn" style={{ background: "#f0f0f0", color: "#555", height: 40 }}
                onClick={() => setEditFormData({
                  name: "", stateId: "", status: "", minimumPrice: "",
                  deliveryCharge: "", freeDeliveryLimit: "",
                  payDeliveryInAdvance: false, deliveryOptionAvailable: [], _id: "",
                })}>
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: 40, opacity: editValid && !isLoading ? 1 : 0.5 }}
                disabled={!editValid || isLoading}
                onClick={editValid && !isLoading ? handleUpdateCityFunc : undefined}
              >
                {isLoading ? "Saving..." : "Update City"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CityList;